export default "/images/combined-shape.svg?b6797dc82923c7823a09a03731b26f1c";